const BASE = process.env.REACT_APP_API_URL || "http://localhost:4000";

function authHeaders() {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

async function request(path, options = {}) {
  const res = await fetch(`${BASE}${path}`, {
    ...options,
    headers: { "Content-Type": "application/json", ...authHeaders(), ...options.headers },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || "Errore di rete.");
  return data;
}

export const api = {
  login: (username, password) =>
    request("/api/auth/login", { method: "POST", body: JSON.stringify({ username, password }) }),

  forgotPassword: (email) =>
    request("/api/auth/forgot-password", { method: "POST", body: JSON.stringify({ email }) }),

  resetPassword: (token, password) =>
    request("/api/auth/reset-password", { method: "POST", body: JSON.stringify({ token, password }) }),

  getUsers: () => request("/api/auth/users"),

  getMessages: (partnerId, before) =>
    request(`/api/messages/${partnerId}${before ? `?before=${before}` : ""}`),

  uploadFile: (file) => {
    const form = new FormData();
    form.append("file", file);
    return fetch(`${BASE}/api/upload`, {
      method: "POST",
      headers: authHeaders(),
      body: form,
    }).then((r) => r.json());
  },

  mediaUrl: (path) => `${BASE}${path}`,

  getEmailLog: () => request("/api/email/log"),
  getEmailStats: () => request("/api/email/stats"),
  getDigestPreview: () => request("/api/email/digest-preview"),
  sendDigest: () => request("/api/email/send-digest", { method: "POST" }),
  sendTestEmail: (to, note) =>
    request("/api/email/send-test", { method: "POST", body: JSON.stringify({ to, note }) }),
};
